import { render, staticRenderFns } from "./stricken02.vue?vue&type=template&id=f447c7c8&scoped=true"
import script from "./stricken02.vue?vue&type=script&lang=js"
export * from "./stricken02.vue?vue&type=script&lang=js"
import style0 from "./stricken02.vue?vue&type=style&index=0&id=f447c7c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f447c7c8",
  null
  
)

export default component.exports